module.exports = __webpack_public_path__ + "img/pic-about.dafa3356.jpg";